import Vue from "vue";
import VueI18n from "vue-i18n";

import { getEnv } from "../utils/env";
// const env = require("../utils/env").env

const utils = require("../utils");

Vue.use(VueI18n);

const userLocale = null;
let i18n = "";

function loadLocaleMessages() {
	const locales = require.context(
		"../locales",
		true,
		/[A-Za-z0-9-_,\s]+\.json$/i
	);
	const messages = {};
	locales.keys().forEach((key) => {
		const matched = key.match(/([A-Za-z0-9-_]+)\./i);
		if (matched && matched.length > 1) {
			const locale = matched[1];
			messages[locale] = locales(key);
		}
	});
	return messages;
}

const determineUserLocale = (path = null) => {
	let userLocale = "";
	const env = getEnv();

	if (process.env.DEPLOY_ENV == "mobile_app") {
		userLocale = localStorage.hasOwnProperty("DEFAULT_LOCALE")
			? localStorage.getItem("DEFAULT_LOCALE")
			: env.locale;

		if (!localStorage.hasOwnProperty("DEFAULT_LOCALE")) {
			localStorage.setItem("DEFAULT_LOCALE", env.locale);
		}
	}
	if (process.env.DEPLOY_ENV == "web") {
		let pathName = window.location.pathname;
		let localeFromUrl = pathName.split("/");

		let countryAvailableLocales = env.availableCountries.find((country) => {
			return country.code == process.env.COUNTRY_CODE;
		});
		let availableLocales = countryAvailableLocales.availableLocales;

		if (
			(localeFromUrl.length > 2 &&
				!availableLocales.includes(localeFromUrl[1])) ||
			!(localeFromUrl.length > 2)
		) {
			userLocale = env.locale;
		} else {
			userLocale = localeFromUrl[1];
		}

		utils.cookie.set("btk-lang-cn", userLocale, 10 * 365);
	}

	return userLocale;
};

// TODO: Export set locale method that stores chosen locale to localStorage
//TODO: Get default locale from env file or localStorage depending on deploy ENV

const initializeLocales = () => {
	return new Promise((resolve) => {
		i18n = new VueI18n({
			locale: determineUserLocale(),
			fallbackLocale: getEnv().locale || "en-ke",
			messages: loadLocaleMessages(),
		});
		resolve(i18n);
	});
};

const setLocale = (locale) => {
	i18n.locale = locale;
	if (process.env.DEPLOY_ENV == "mobile_app") {
		localStorage.setItem("DEFAULT_LOCALE", locale);
	}
	if (process.env.DEPLOY_ENV == "web") {
		utils.cookie.set("btk-lang-cn", locale, 10 * 365);
	}
};

export { i18n, setLocale, initializeLocales };
